import { friendlyErrorMessage } from '@/core/lib/dbError'
import { assertWriteIdentity, captureWriteIdentity, type WriteIdentity } from '@/core/api/http'

import { renderSignedDocument } from '@/core/api/documentsRender'
import { ok, technical, type Result } from '@/core/lib/result'

export async function renderBericht(coachingId: string, identity: WriteIdentity = captureWriteIdentity()): Promise<Result<void>> {
  try {
    await renderSignedDocument('bericht', coachingId, identity)
    assertWriteIdentity(identity)
    return ok(undefined)
  } catch (error) {
    assertWriteIdentity(identity)
    return technical(friendlyErrorMessage(error, "Bericht-PDF konnte nicht erstellt werden."))
  }
}
